export const ID_HOLIDAYPARK = 21
export const ID_SAFARIRESORT = 2041
